import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "column is-one-quarter" }
const _hoisted_2 = { class: "column is-three-quarter content" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_Forms = _resolveComponent("Forms")!
  const _component_Task = _resolveComponent("Task")!
  const _component_NoTask = _resolveComponent("NoTask")!

  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["columns is-gapless is-multiline", { 'dark-mode': _ctx.setModeActive }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SideBar, { onChangedTheme: _ctx.changingTheme }, null, 8, ["onChangedTheme"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Forms, {
        placeholder: "Qual tarefa você vai começar agora? 😏",
        onSavingTask: _ctx.saveTask
      }, null, 8, ["onSavingTask"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.taskSaveLocalStorage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasksSaved, (task, index) => {
                return (_openBlock(), _createBlock(_component_Task, {
                  key: index,
                  completedTask: task
                }, null, 8, ["completedTask"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task, index) => {
          return (_openBlock(), _createBlock(_component_Task, {
            key: index,
            completedTask: task
          }, null, 8, ["completedTask"]))
        }), 128)),
        (_ctx.tasksEmpty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_NoTask)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}